import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { isType } from '@sorare/core/src/lib/gql';
import type { Color } from '@sorare/core/src/style/types';

import type { GamesStanding_TeamInterface } from './__generated__/index.graphql';

type Props = {
  team: GamesStanding_TeamInterface;
  color?: Color;
  withParens?: boolean;
};

export const GamesStanding = ({ team, color, withParens = false }: Props) => {
  if (!isType(team, 'Club')) return null;

  return (
    <LabelS as="span" color={color}>
      {!!withParens && '('}
      {team?.activeContestant?.gamesWon || 0}-
      {team?.activeContestant?.gamesLost || 0}
      {!!withParens && ')'}
    </LabelS>
  );
};

GamesStanding.fragments = {
  TeamInterface: gql`
    fragment GamesStanding_TeamInterface on TeamInterface {
      slug
      ... on Club {
        slug
        activeContestant {
          id
          gamesWon
          gamesLost
        }
      }
    }
  ` as TypedDocumentNode<GamesStanding_TeamInterface>,
};
